export const SOLV_SECTION_TITLE = 'SOLV OVERVIEW';
export const PRACTICE_SECTION_TITLE = 'FROM THE PRACTICE';
